import { ApplicationConfig, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

import { registerLocaleData } from '@angular/common';
import frBE from '@angular/common/locales/fr-BE'
import enBE from '@angular/common/locales/en-BE'
import { environment } from '../environments/environment';
import { tokenInterceptorFn } from './interceptors/token.interceptor';

export const API_URL = new InjectionToken<string>('API_URL');

export interface CaptchaConfig {
  enabled: boolean;
  /** URL of the self-hosted ALTCHA widget script (served from our own assets) */
  widget_url: string;
  /**
   * Challenge endpoint for the widget. Leave empty to use the backend's own
   * `GET <api_url>/captcha/challenge` (recommended: same-origin, no CORS).
   * Set only to use an external ALTCHA server.
   */
  challenge_url: string;
}
export const CAPTCHA_CONFIG = new InjectionToken<CaptchaConfig>('CAPTCHA_CONFIG');
export const LOGIN_URL = new InjectionToken<string>('LOGIN_URL');
export const RESET_PASSWORD_URL = new InjectionToken<string>('RESET_PASSWORD_URL');
export const SET_PASSWORD_URL = new InjectionToken<string>('SET_PASSWORD_URL');
export const ERROR_URL = new InjectionToken<string>('ERROR_URL');

registerLocaleData(frBE);
registerLocaleData(enBE);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([tokenInterceptorFn]) // functional interceptor
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto', appearance: 'fill' } },
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
    { provide: CAPTCHA_CONFIG, useValue: environment.captcha },
    { provide: API_URL, useValue: environment.api_url },
    { provide: LOGIN_URL, useValue: 'auth/signin' },
    { provide: RESET_PASSWORD_URL, useValue: 'auth/resetpassword' },
    { provide: SET_PASSWORD_URL, useValue: 'auth/setpassword' },
    { provide: ERROR_URL, useValue: 'error/' },
    //{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }, 
  ]
};
